import React, { forwardRef } from 'react';
import { css, cx } from '@emotion/css';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

const inputBase = css({
  width: '100%',
  padding: 'var(--spacing-sm) var(--spacing-md)',
  fontSize: 'var(--fs-400)',
  fontFamily: 'inherit',
  color: 'var(--g-800)',
  backgroundColor: 'var(--primary-color)',
  border: '1px solid var(--pc-200)',
  borderRadius: 'var(--spacing-xs)',
  outline: 'none',
  transition: 'all 0.2s ease',

  '&:focus': {
    borderColor: 'var(--pc-500)',
    boxShadow: '0 0 0 3px rgba(var(--pcrgba-200), 0.3)',
  },

  '&:disabled': {
    backgroundColor: 'var(--g-100)',
    cursor: 'not-allowed',
    opacity: 0.6,
  },

  '&::placeholder': {
    color: 'var(--g-400)',
  },
});

const inputError = css({
  borderColor: 'var(--error-color, #e53e3e)',
  
  '&:focus': {
    borderColor: 'var(--error-color, #e53e3e)',
    boxShadow: '0 0 0 3px rgba(229, 62, 62, 0.2)',
  },
});

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={cx(inputBase, error && inputError, className)}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

export default Input;
